import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchInstructors = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/instructors${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createInstructor = async (data) => {
  const response = await fetch(`${API_BASE_URL}/instructors`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateInstructor = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/instructors/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteInstructor = async (id) => {
  const response = await fetch(`${API_BASE_URL}/instructors/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchInstructorSessionCounts = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/instructors/session-counts${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const copyInstructorsToAcademicYear = async (data) => {
  const response = await fetch(`${API_BASE_URL}/instructors/copy`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

